/**
 * Maps GET /api/oshar-real-estate/tiers tier objects into the shape expected by
 * PropertyTypeGrid / RealEstateDetailModal (mirrors src/data/osharRealEstate.js assetTypes).
 */

function priceLabelFromUsd(priceUsd, needsConfirmation) {
  if (needsConfirmation || priceUsd == null || !Number.isFinite(Number(priceUsd))) {
    return "TBD";
  }
  const n = Number(priceUsd);
  return `$${n.toLocaleString(undefined, { maximumFractionDigits: 0 })}`;
}

/**
 * @param {object} d — one element from API `tiers` array
 */
export function mapPublicOsharTierDtoToAssetType(d) {
  const status = String(d?.status || "available").toLowerCase();
  const statusOverride =
    status === "reserved" ? "reserved" : status === "unavailable" ? "unavailable" : null;

  const priceUsd = d.priceUsd != null && Number.isFinite(Number(d.priceUsd)) ? Number(d.priceUsd) : null;
  const needs = Boolean(d.priceUsdNeedsConfirmation || d.needsConfirmation);

  const totalSupply = Number(d.totalSupply) || 0;
  const remaining =
    d.remaining != null && Number.isFinite(Number(d.remaining)) ? Number(d.remaining) : totalSupply;
  const maxPerCheckout =
    d.maxPerCheckout != null && Number.isFinite(Number(d.maxPerCheckout))
      ? Number(d.maxPerCheckout)
      : Math.min(50, Math.max(1, remaining));

  return {
    id: d.tierSlug,
    tierSlug: d.tierSlug,
    entitlementType: d.entitlementType || "vr_real_estate",
    propertyCategory: d.propertyCategory || null,
    name: d.displayName,
    supply: totalSupply,
    remaining,
    reserved: d.reserved != null ? Number(d.reserved) : undefined,
    sold: d.sold != null ? Number(d.sold) : undefined,
    maxPerCheckout,
    /** Only explicit `false` from API disables card checkout; omit/undefined allows price/inventory checks in the modal. */
    checkoutEnabled:
      d.checkoutEnabled === false ? false : d.checkoutEnabled === true ? true : undefined,
    disabledReason: d.disabledReason || null,
    price: priceUsd ?? 0,
    priceLabel: d.priceLabel || priceLabelFromUsd(priceUsd, needs),
    useCase: d.shortDescription || "",
    imageKey: d.imageKey,
    tokenId: Number(d.tokenId),
    district: d.district,
    assetType: d.assetType,
    saleTierLabel: d.saleTierLabel,
    shortDescription: d.shortDescription,
    description: d.description,
    statusOverride,
    reservationNote: d.reservationNote,
    reservedBy: d.reservedBy,
    usdcPrice: needs ? null : priceUsd,
    priceUsdNeedsConfirmation: needs,
    needsConfirmation: needs,
    utilityList: Array.isArray(d.utilityList) ? d.utilityList : [],
  };
}

export function mapPublicOsharTierListToAssetTypes(tiers) {
  if (!Array.isArray(tiers) || !tiers.length) return [];
  return tiers.map(mapPublicOsharTierDtoToAssetType);
}
